// Func = limiting Scope for this file
var lastScrollTop = 0;

(function(){
	
	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
		});

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			//scrollW();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$('.gallery-projects__holder').slick({
			infinite: false,
			dots: true,
			arrows: true,
			slidesToShow: 1,
			appendArrows: '.arrows-gallery',
			slidesToScroll: 1,
			responsive: [
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true
				  }
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			  ]
		});

		$(".custom-option").click(function(){
			$(this).siblings(".custom-option.selected").removeClass("selected");
			$(this).addClass("selected");
		});
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		//scrollW();
		window.addEventListener('scroll', function(){
			//scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


$('.plans-content__pick--title').click( function() {
	$(this).parent().addClass('active').siblings().removeClass('active');
	window.scrollTo({ top: $(this).offsetTop, behavior: 'smooth' });
});

$('.plans-content__pick--title').click(function(e) {
    e.preventDefault();
	var $this = $(this);
    if ($this.hasClass('show')) {
		$this.find('.btn-text').html('Show Programs Inclusions');
		$this.next().slideUp(350);
		$this.removeClass('show');
    } else {
		$this.find('.btn-text').html('Hide Programs Inclusions');
		$this.next().slideToggle(350);
		$this.toggleClass('show');
		$this.addClass('show');
	}
	
});

// Custom select

$('select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;
  
    $this.addClass('select-hidden'); 
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());
  
    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);
  
    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
    }
  
    var $listItems = $list.children('li');
  
    $styledSelect.click(function(e) {
		e.stopPropagation();
		$styledSelect.text("I'm Interested In");
        $('div.select-styled.active').not(this).each(function(){
        	$(this).removeClass('active').next('ul.select-options').hide();
        });
		$(this).toggleClass('active').next('ul.select-options').toggle();
		$('.arrow-select').addClass('active');
    });
    $listItems.click(function(e) {
		e.stopPropagation();
		//$styledSelect.text("I'm Interested In");
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
        $list.hide();
		$('.arrow-select').removeClass('active');
		
    });
  
    $(document).click(function() {
        $styledSelect.removeClass('active');
		$list.hide();
		$('.arrow-select').removeClass('active');
	});
	
});

// Accordion 
$('.accordion-item button').click(function(e) {
	e.preventDefault();

  var $this = $(this);

  if ($this.hasClass('show')) {
	  $this.next().removeClass('show');
	  $this.next().slideUp(350);
	  $this.removeClass('show');
  } else {
	  $this.addClass('show');
	  $this.next('.accordion-content').removeClass('show');
	  $this.next('.accordion-content').slideUp(350);
	  $this.parent().parent().parent().parent().find('.accordion-content').slideUp(350);
	  $this.next().toggleClass('show');
	  $this.next().slideToggle(350);
	  
  }
});


